<template>
  <div class="mypage-ec-site-connect-page">
    <sub-header-section
      :pageTitle="$tc('MypagePage.MypageEcSiteConnectPage.title')"
      backLink="/mypage"
    />
    <mypage-ec-site-connect-pane />
    <global-navigation-pane current="mypage" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import MypageEcSiteConnectPane from '@/components/MypageEcSiteConnectPage/MypageEcSiteConnectPane.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'

export default defineComponent({
  name: 'MypageEcSiteConnectPage',
  components: { GlobalNavigationPane, MypageEcSiteConnectPane, SubHeaderSection },
})
</script>
